import { mergeMap, Observable, OperatorFunction } from 'rxjs';

export interface GrpcStreamResponse<M> {
  message: { case: 'Message'; value: M } | { case: 'Ping' | undefined; value?: unknown };
}

export function fromServerStream<T>(open: (signal: AbortSignal) => AsyncIterable<T>): Observable<T> {
  return new Observable<T>(subscriber => {
    const controller = new AbortController();
    const pump = async () => {
      for await (const message of open(controller.signal)) {
        subscriber.next(message);
      }
      subscriber.complete();
    };
    pump().catch(error => {
      if (!controller.signal.aborted) subscriber.error(error);
    });
    return () => controller.abort();
  });
}

export function messagesOnly<M>(): OperatorFunction<GrpcStreamResponse<M>, M> {
  return mergeMap(({ message }) => (message.case === 'Message' ? [message.value] : []));
}
